import React from "react";

function Encabezado() {
  return (
    <div>
      <div className="text-center">
        <div class="card-header py-3">
          <h5 class="m-0 font-weight-bold text-primary">
            INFORME DE AUTOEVALUACIÓN ESTÁNDARES IPS HOSPITALARIAS PERFIL DE LA
            INSTITUCIÓN Y AUTOEVALUACION VISITA DE SEGUIMIENTO
            <br></br>
            VERSIÓN 3.1 RESOLUCIÓN 5095 DE 2018
          </h5>
        </div>
      </div>
      <div className="text-justify">
        <div class="table-responsive">
          <center>
            <table border={0}>
              <thead>
                <tr>
                  <div className="text-center">
                    <th>
                      <h6 class="m-0 font-weight-bold text-primary">INDICE</h6>
                    </th>
                    <br></br>
                  </div>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <h6>SECCION A. INFORMACIÓN GENERAL DE LA INSTITUCIÓN </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>SECCION B. DESCRIPCIÓN DE LOS SERVICIOS</h6>{" "}
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>1. SERVICIOS HOSPITALARIOS</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>2. SERVICIOS AMBULATORIOS</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>3. REHABILITACIÓN </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>4. SERVICIOS DE ODONTOLOGÍA</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>5. IMÁGENES DIAGNÓSTICAS Y TERAPÉUTICA</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>6. LABORATORIO CLÍNICO, BANCO DE SANGRE Y PATOLOGÍA</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>7. SEDES INTEGRADAS</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>
                      SECCIÓN C. INFRAESTRUCTURA Y GESTION DE TECNOLOGÍA
                      BIOMÉDICA
                    </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>
                      SECCIÓN D. DISTRIBUCIÓN Y DESARROLLO DEL TALENTO HUMANO{" "}
                    </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>SECCION E. GESTION DE LA INFORMACIÓN</h6>
                  </td>
                </tr>
              </tbody>
            </table>
          </center>
        </div>
      </div>
    </div>
  );
}

export default Encabezado;
